import { Outlet } from 'react-router-dom'
import TopBar from '../components-admin/TopBar'

export default function AdminLayout() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #f8faf8 0%, #f2f5f2 100%)',
      }}
    >
      <TopBar />
      <main style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
        <Outlet />
      </main>
    </div>
  )
}
